import Grid from 'antd-mobile/lib/grid';
export default Grid;



// WEBPACK FOOTER //
// ./components/grid/index.tsx